import { render, staticRenderFns } from "./set-prize.vue?vue&type=template&id=19409806&scoped=true"
import script from "./set-prize.vue?vue&type=script&lang=js"
export * from "./set-prize.vue?vue&type=script&lang=js"
import style0 from "./set-prize.vue?vue&type=style&index=0&id=19409806&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19409806",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/pre-ops-admin 管理后台-预发布环境/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('19409806')) {
      api.createRecord('19409806', component.options)
    } else {
      api.reload('19409806', component.options)
    }
    module.hot.accept("./set-prize.vue?vue&type=template&id=19409806&scoped=true", function () {
      api.rerender('19409806', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/marketing/activities/components/set-prize.vue"
export default component.exports